import type { FileConfig } from '../types/FileConfig';

/**
 * Configuration objects for HopTx tool file types
 * Each config defines how to parse a specific HopTx CSV file format
 */
export const HOPTX_CONFIGS: Record<string, FileConfig> = {
  HOPTX_SYSTEM: {
    timeColumns: ['Time (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['Clock Ticks (ms)', 'Time (seconds)', 'System Event', 'Other Info'], // System status and configuration data
    toolType: 'HopTx',
    fileType: 'EM_HOPTX_SYSTEM',
    dataType: 'timeseries'
  },
  HOPTX_TX: {
    timeColumns: ['Time (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['Clock Ticks (ms)', 'Time (seconds)', 'Symbol 1', 'Symbol 2', 'Symbol 80'], // Transmitter operation data (80 symbols total)
    toolType: 'HopTx',
    fileType: 'EM_HOPTX_TX',
    dataType: 'timeseries'
  },
  HOPTX_VOLTAGES: {
    timeColumns: ['Time (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['Clock Ticks (ms)', 'Time (seconds)', '5V min (V)', '5V max (V)', '5V mean (V)', '5V std dev (V)', '3.3V min (V)', '3.3V max (V)', '3.3V mean (V)', '3.3V std dev (V)', '12V min (V)', '12V max (V)', '12V mean (V)', '12V std dev (V)'], // Voltage monitoring for power management (13 columns total)
    toolType: 'HopTx',
    fileType: 'EM_HOPTX_VOLTAGES',
    dataType: 'timeseries'
  }
};